import { useEffect, useState } from 'react';
import api from '@/api/axios';

const TIPO_TL = {
  call: { e: '📞', l: 'Llamada', c: '#6C3FB5' },
  visit: { e: '📍', l: 'Visita', c: '#E99A22' },
  quote: { e: '📄', l: 'Cotización', c: '#A855F7' },
  sale: { e: '💰', l: 'Venta', c: '#10B981' },
  cotizacion: { e: '🧾', l: 'Cotización', c: '#1D4ED8' },
  presupuesto: { e: '📐', l: 'Presupuesto SA', c: '#4B1D73' },
  lead: { e: '🌐', l: 'Lead', c: '#06B6D4' },
  ficha: { e: '🪪', l: 'Ficha', c: '#6B6B6B' },
};

export const TimelineCliente = ({ cid }) => {
  const [tl, setTl] = useState(null);
  useEffect(() => {
    api.get(`/clientes/${cid}/timeline`)
      .then((r) => setTl(r.data.eventos || []))
      .catch(() => setTl([]));
  }, [cid]);
  const fmtFecha = (f) => {
    try { return new Date(f).toLocaleDateString('es-GT', { day: '2-digit', month: 'short', year: 'numeric' }); }
    catch { return String(f).slice(0, 10); }
  };
  return (
    <div className="border border-[#6C3FB5]/30 bg-[#6C3FB5]/5 rounded-lg p-3" data-testid="cli-ficha-timeline">
      <p className="text-[10px] font-black uppercase text-[#6C3FB5] mb-2">🕒 Línea de tiempo {tl ? `(${tl.length})` : ''}</p>
      {!tl ? (
        <p className="text-[11px] text-[var(--text-muted)]">Cargando línea de tiempo…</p>
      ) : tl.length === 0 ? (
        <p className="text-[11px] text-[var(--text-muted)] italic">Sin eventos registrados con este cliente.</p>
      ) : (
        <div className="relative pl-5 max-h-72 overflow-y-auto">
          <div className="absolute left-[7px] top-1 bottom-1 w-px bg-[#6C3FB5]/30" />
          {tl.map((ev, i) => {
            const m = TIPO_TL[ev.tipo] || TIPO_TL.ficha;
            return (
              <div key={i} className="relative pb-2.5" data-testid={`tl-evento-${i}`}>
                <span className="absolute -left-[18px] top-0.5 w-4 h-4 rounded-full flex items-center justify-center text-[9px]"
                  style={{ background: `${m.c}22`, border: `1.5px solid ${m.c}` }}>{ev.tipo === 'ficha' ? '•' : ''}</span>
                <div className="flex items-start justify-between gap-2">
                  <p className="text-[11px] font-bold text-[var(--text)] leading-tight">
                    {m.e} {ev.titulo}
                    {ev.monto != null && <span className="font-black" style={{ color: m.c }}> · Q{Number(ev.monto).toLocaleString('es-GT')}</span>}
                  </p>
                  <span className="text-[9px] font-bold text-[var(--text-muted)] shrink-0">{fmtFecha(ev.fecha)}</span>
                </div>
                {ev.detalle && <p className="text-[10px] text-[var(--text-muted)] leading-tight">{ev.detalle.length > 90 ? ev.detalle.slice(0, 90) + '…' : ev.detalle}</p>}
                {ev.usuario && <p className="text-[9px] text-[var(--text-faint)]">👤 {ev.usuario}</p>}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
